import angular from 'angular';
import pluginComponent from './plugin.component';

let pluginModule = angular.module('plugin', [])

    .component('plugin', pluginComponent)

.name;

let states = [
    {
        name: 'plugin',
        url: '/plugin',
        component: 'plugin',
        title: 'face-plugin-title'
    }
];

export default {name: pluginModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/face/plugin/plugin.js